import type { PublicPhoto } from "../api/photos";
import styles from "./PhotoCard.module.css";

interface PhotoCardProps {
  photo: PublicPhoto;
  onClick: () => void;
  selectionMode?: boolean;
  selected?: boolean;
}

export function PhotoCard({ photo, onClick, selectionMode, selected }: PhotoCardProps) {
  return (
    <button
      className={`${styles.card} ${selected ? styles.cardSelected : ""}`}
      onClick={onClick}
      aria-label={selectionMode ? "Sélectionner la photo" : "Agrandir la photo"}
    >
      <img className={styles.image} src={photo.thumbUrl} alt="" loading="lazy" />
      {photo.mediaType === "video" && (
        <span className={styles.playBadge} aria-hidden="true">
          ▶️
        </span>
      )}
      {selectionMode && (
        <span className={`${styles.checkmark} ${selected ? styles.checkmarkChecked : ""}`} aria-hidden="true">
          {selected ? "✓" : ""}
        </span>
      )}
    </button>
  );
}
